import { render, staticRenderFns } from "./ModelBrowserOverlay.vue?vue&type=template&id=ce84f382&scoped=true&"
import script from "./ModelBrowserOverlay.vue?vue&type=script&lang=ts&"
export * from "./ModelBrowserOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./ModelBrowserOverlay.vue?vue&type=style&index=0&id=ce84f382&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce84f382",
  null
  
)

export default component.exports